import { createReducer } from "@reduxjs/toolkit";
import { ORDER_LOADING, ORDER_ERROR, PUT_ORDER } from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const orderReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(ORDER_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(ORDER_ERROR, (state, { payload }) => {
      state.error = payload;
    })
    .addCase(PUT_ORDER, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default orderReducer;
